import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Pending } from "../ui/Pending";
import { faqs } from "../../data/content";
import { offer } from "../../data/offer";
type Item = {
  q: string;
  a: React.ReactNode;
};
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const items: Item[] = [...faqs, {
    q: "How do I receive it, and for how long can I access it?",
    a: offer.delivery || offer.accessDuration ? "The manual and all five bonuses are sent to your email after purchase, and you keep lifetime access." : <Pending label="delivery and access" data-id="element-41" data-mp="1g0bj3rh9qnh8" />
  }, {
    q: "How can I pay?",
    a: <>
          A single one-time payment of {offer.price} {offer.currency} — no subscription.{" "}
          {offer.paymentMethods.length ? `Accepted: ${offer.paymentMethods.join(", ")}.` : <Pending label="payment methods" data-id="element-42" data-mp="2dj39e0rq3at8" />}
        </>
  }, {
    q: "Is there a guarantee?",
    a: offer.guarantee ? offer.guarantee.terms.join(" ") : <Pending label="guarantee terms" data-id="element-43" data-mp="2js725iegtdqq" />
  }];
  return <section className="bg-ivory py-16 md:py-24" data-id="element-44" data-mp="2yg1v8zwdxk4c">
      <div className="mx-auto max-w-[820px] px-5 md:px-8" data-id="element-45" data-mp="2ygtow56f97rz">
        <h2 className="heading text-center text-[40px] text-forest md:text-[60px]" data-id="element-46" data-mp="2tos763qhiouk">
          Frequently asked <span className="text-sand-deep" data-id="element-47" data-mp="37g71v7tr8ehg">questions</span>
        </h2>
        <div className="mt-10 space-y-3" data-id="element-48" data-mp="37ijk7m3fcqv1">
          {items.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="overflow-hidden rounded-2xl border border-line bg-cream" data-id="element-49" data-mp="3hf5z7u92knp5" data-mpi={i}>
                <h3 className="m-0" data-id="element-50" data-mp="3cgurbp2c4n9k">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-[17px] font-bold text-charcoal md:px-6" data-id="element-51" data-mp="3cdqgi8ud6t9x">
                    {item.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-sand-deep transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-52" data-mp="2bskhre65vet8" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-53" data-mp="2qpbknxf1n8nl">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-54" data-mp="2uqdl2hkp5qr5">
                      <div className="px-5 pb-5 text-[16px] leading-relaxed text-muted md:px-6" data-id="element-55" data-mp="39fjfls8lassp">{item.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}